import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToClaimProfessionalType = mapDictionaryState;

const claimProfessionalTypeApi = createDictionaryApiFactory("claimProfessionalType");

export const getClaimProfessionalType = claimProfessionalTypeApi.search;
export const getClaimProfessionalTypeDetail = claimProfessionalTypeApi.getDetail;
export const createClaimProfessionalType = claimProfessionalTypeApi.save;
export const exportCsvClaimProfessionalType = claimProfessionalTypeApi.exportCsv;